import { Controller } from '@hotwired/stimulus';

// copy_from_if in the form yml: fills this field from another one while a condition on a field holds.
// The condition is written like data-show-only-if: "field=value", "field!=value" or "field=a|b".
// While the condition holds the field follows its source, when it stops holding the copy is removed again.
// A value the user typed (anything but the last copy) is never overwritten or cleared.
export default class extends Controller {
  static values = { source: String, condition: String };

  connect() {
    this.form = this.element.closest('form');
    this.sourceField = document.getElementById(this.sourceValue);
    if (!this.sourceField) return;

    const [rawName, expectedValue] = this.conditionValue.split('=');
    this.isNegation = rawName.endsWith('!');
    this.expectedValue = expectedValue;
    this.conditionName = this.isNegation ? rawName.slice(0, -1) : rawName;

    this.watched = [
      this.sourceField,
      ...this.form.querySelectorAll(`[name="${this.conditionName}"]`),
    ];
    this.boundSync = this.sync.bind(this);
    for (const field of this.watched) {
      field.addEventListener('input', this.boundSync);
      field.addEventListener('change', this.boundSync);
    }
    this.sync();
  }

  disconnect() {
    for (const field of this.watched || []) {
      field.removeEventListener('input', this.boundSync);
      field.removeEventListener('change', this.boundSync);
    }
  }

  conditionHolds() {
    const value = this.form.querySelector(`[name="${this.conditionName}"]`)?.value;

    return this.isNegation
      ? value !== this.expectedValue
      : this.expectedValue.split('|').includes(value);
  }

  sync() {
    const field = this.element;
    if (!(field.value === '' || field.value === field.dataset.copiedValue)) return;

    const newValue = this.conditionHolds() ? this.sourceField.value : '';
    if (field.value === newValue) return;

    field.value = newValue;
    // lets the validation controller format the currency field and fill its hidden raw value
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dataset.copiedValue = field.value;
  }
}
